export enum OutputType {
  CONDITION = 'CONDITION',
  SIGNAL = 'SIGNAL',
}

export enum OnnxResultType {
  OnnxPredictionModel = 'OnnxPredictionModel',
  OnnxAnomalyModel = 'OnnxAnomalyModel',
}
